const mediaItems = [
  {
    title: '布丁漫画使用指南：下拉式阅读入门',
    desc: '3分钟教你掌握布丁漫画下拉式阅读的所有技巧和便捷功能。',
    duration: '03:26',
    views: '12.5w',
    image: 'https://readdy.ai/api/search-image?query=Tutorial%20style%20illustration%20showing%20a%20hand%20scrolling%20on%20a%20tablet%20with%20colorful%20manga%20panels%2C%20clean%20modern%20flat%20design%2C%20warm%20coral%20and%20amber%20tones%2C%20educational%20and%20friendly%20atmosphere&width=640&height=360&seq=media-01&orientation=landscape',
  },
  {
    title: '韩漫推荐：这五部恋爱漫画甜到掉牙',
    desc: '布丁漫画编辑精选五部必看的韩漫恋爱作品，每一部都让人上头。',
    duration: '08:15',
    views: '9.8w',
    image: 'https://readdy.ai/api/search-image?query=Collection%20of%20five%20romantic%20Korean%20webtoon%20style%20covers%20arranged%20in%20a%20grid%2C%20soft%20pink%20and%20coral%20warm%20tones%2C%20clean%20layout%2C%20elegant%20presentation&width=640&height=360&seq=media-02&orientation=landscape',
  },
  {
    title: '国漫崛起之路：从模仿到创新的蜕变',
    desc: '探讨近年来国漫在题材、画风和叙事上的突破性发展。',
    duration: '12:40',
    views: '6.3w',
    image: 'https://readdy.ai/api/search-image?query=Timeline%20evolution%20of%20Chinese%20manga%20art%20style%20from%20traditional%20to%20modern%2C%20showcasing%20artistic%20growth%2C%20warm%20gold%20and%20coral%20tones%2C%20clean%20digital%20art%2C%20progressive%20design&width=640&height=360&seq=media-03&orientation=landscape',
  },
  {
    title: '漫画家访谈：揭秘《重生之都市修仙》创作幕后',
    desc: '独家专访当红漫画作者，了解作品诞生背后的故事和创作理念。',
    duration: '15:22',
    views: '18.2w',
    image: 'https://readdy.ai/api/search-image?query=Artist%20studio%20setting%20with%20digital%20drawing%20tablet%20displaying%20manga%20panels%2C%20creative%20workspace%2C%20warm%20ambient%20lighting%2C%20coral%20and%20amber%20tones%2C%20professional%20creative%20environment&width=640&height=360&seq=media-04&orientation=landscape',
  },
  {
    title: '布丁漫画夏日阅读挑战赛活动回顾',
    desc: '数千读者参与的夏日阅读打卡活动精彩瞬间和获奖名单公布。',
    duration: '05:48',
    views: '7.1w',
    image: 'https://readdy.ai/api/search-image?query=Summer%20theme%20illustration%20with%20diverse%20people%20reading%20manga%20on%20various%20devices%20in%20bright%20sunny%20setting%2C%20warm%20vibrant%20coral%20and%20amber%20tones%2C%20energetic%20and%20fun%20atmosphere&width=640&height=360&seq=media-05&orientation=landscape',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
              精彩视频
            </h2>
            <p className="text-sm text-foreground-500 max-w-xl mx-auto">
              布丁漫画相关的精彩视频内容，带你了解更多漫画背后的故事
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
            {mediaItems.map((item, i) => {
              const isLarge = i < 2;
              return (
                <div
                  key={i}
                  className={`group rounded-2xl overflow-hidden bg-background-50 border border-background-200/70 hover:border-primary-200 transition-all duration-300 cursor-pointer ${
                    isLarge ? 'lg:col-span-1' : 'lg:col-span-1'
                  } ${
                    i === 0 ? 'sm:col-span-2 lg:col-span-2' : ''
                  }`}
                >
                  <div className={`relative overflow-hidden bg-background-100 ${i === 0 ? 'aspect-[16/9]' : 'aspect-video'}`}>
                    <img
                      src={item.image}
                      alt={`布丁漫画视频 - ${item.title}`}
                      className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                      title={`布丁漫画下拉式看 ${item.title}`}
                    />
                    <div className="absolute inset-0 flex items-center justify-center">
                      <div className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center rounded-full bg-primary-500/90 text-background-50 group-hover:bg-primary-500 group-hover:scale-110 transition-all duration-300">
                        <i className="ri-play-fill text-xl md:text-2xl ml-0.5"></i>
                      </div>
                    </div>
                    <div className="absolute bottom-3 right-3 px-2 py-1 rounded bg-background-950/70 text-background-50 text-xs font-medium whitespace-nowrap">
                      {item.duration}
                    </div>
                  </div>
                  <div className="p-4">
                    <h3 className="text-sm font-heading font-bold text-foreground-900 mb-1.5 line-clamp-1">
                      {item.title}
                    </h3>
                    <p className="text-xs text-foreground-500 leading-relaxed mb-2 line-clamp-2">
                      {item.desc}
                    </p>
                    <div className="flex items-center gap-3">
                      <span className="text-xs text-foreground-400 flex items-center gap-1">
                        <i className="ri-eye-line"></i> {item.views}
                      </span>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}